import { Navigate } from "react-router-dom";

import { Paths } from "@/core/constants/paths";
import { AppLayout } from "@/modules/global/layout";
import { EmbarcacoesPage } from "@/pages/embarcacoes";
import { FinanceiroConfiguracoesPage } from "@/pages/financeiro/configuracoes";
import { FinanceiroCurvasPage } from "@/pages/financeiro/configuracoes/curvas";
import { FinanceiroDistribuicoesPage } from "@/pages/financeiro/configuracoes/distribuicoes";
import { FinanceiroBaseDadosPage } from "@/pages/financeiro/configuracoes/base-dados";
import { FinanceiroEscoposPadraoPage } from "@/pages/financeiro/configuracoes/escopos-padrao";
import { FinanceiroMoedasPage } from "@/pages/financeiro/configuracoes/moedas";
import { FinanceiroObrasPage } from "@/pages/financeiro/obras";
import { ObrasListaPage } from "@/pages/obras/obras-lista";
import { NovaObraPage } from "@/pages/obras/nova-obra";
import { RecursosPage } from "@/pages/recursos";
import { CargaDeTrabalhoPage } from "@/pages/recursos/carga-de-trabalho";
import { ProfissionaisPage } from "@/pages/recursos/profissionais";
import type { ExtendedRouteObject } from "./types";

export const fieldRoutes: ExtendedRouteObject[] = [
  {
    element: <AppLayout />,
    rules: ["user"],
    scope: ["workspace"],
    children: [
      {
        path: Paths.EMBARCACOES,
        element: <EmbarcacoesPage />,
        rules: ["user"],
        scope: ["workspace"],
      },
      {
        path: Paths.FINANCEIRO,
        element: <FinanceiroConfiguracoesPage />,
        rules: ["user"],
        scope: ["workspace"],
        children: [
          {
            index: true,
            element: <Navigate to={Paths.FINANCEIRO_OBRAS} replace />,
          },
          {
            path: Paths.FINANCEIRO_OBRAS,
            element: <FinanceiroObrasPage />,
            rules: ["user"],
            scope: ["workspace"],
          },
          {
            path: Paths.FINANCEIRO_CONFIGURACOES,
            rules: ["user"],
            scope: ["workspace"],
          },
          {
            path: Paths.FINANCEIRO_CONFIGURACOES_CURVAS,
            element: <FinanceiroCurvasPage />,
            rules: ["user"],
            scope: ["workspace"],
          },
          {
            path: Paths.FINANCEIRO_CONFIGURACOES_DISTRIBUICOES,
            element: <FinanceiroDistribuicoesPage />,
            rules: ["user"],
            scope: ["workspace"],
          },
          {
            path: Paths.FINANCEIRO_CONFIGURACOES_BASE_DADOS,
            element: <FinanceiroBaseDadosPage />,
            rules: ["user"],
            scope: ["workspace"],
          },
          {
            path: Paths.FINANCEIRO_CONFIGURACOES_ESCOPOS_PADRAO,
            element: <FinanceiroEscoposPadraoPage />,
            rules: ["user"],
            scope: ["workspace"],
          },
          {
            path: Paths.FINANCEIRO_CONFIGURACOES_MOEDAS,
            element: <FinanceiroMoedasPage />,
            rules: ["user"],
            scope: ["workspace"],
          },
        ],
      },
      {
        // O acesso é decidido pela API (privilégio `hub.obra:view`): sem ele a listagem
        // apresenta o estado de "sem permissão" a partir do 403.
        // A Nova Obra é filha: abre como modal sobre a lista, que fica montada ao fundo.
        path: Paths.OBRAS,
        element: <ObrasListaPage />,
        rules: ["user"],
        scope: ["workspace"],
        children: [
          {
            path: Paths.OBRAS_NOVA,
            element: <NovaObraPage />,
            rules: ["user"],
            scope: ["workspace"],
          },
        ],
      },
      {
        path: Paths.RECURSOS,
        element: <RecursosPage />,
        rules: ["user"],
        scope: ["workspace"],
        children: [
          {
            index: true,
            element: <Navigate to={Paths.RECURSOS_PROFISSIONAIS} replace />,
          },
          {
            path: Paths.RECURSOS_PROFISSIONAIS,
            element: <ProfissionaisPage />,
            rules: ["user"],
            scope: ["workspace"],
          },
          {
            path: Paths.RECURSOS_CARGA_DE_TRABALHO,
            element: <CargaDeTrabalhoPage />,
            rules: ["user"],
            scope: ["workspace"],
          },
        ],
      },
    ],
  },
];
